export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const ERROR_TYPE = "ERROR_TYPE";
export const SHOW_SUCCESS = "SHOW_SUCCESS";
export const IS_LOGGED_IN = "IS_LOGGED_IN";
export const SET_LOYALTY_DATA = "SET_LOYALTY_DATA";
export const SET_CURRENT_TIER_ID = "SET_CURRENT_TIER_ID";
export const SET_LOYALTY_AVAILABLE = "SET_LOYALTY_AVAILABLE";

export const initialState = {
  loading: true,
  errorCode: "",
  showSuccess: false,
  currentTierId: null,
};

export const toggleLoading = () => ({
  type: TOGGLE_LOADING,
});

export const setErrorCode = (errorCode) => ({
  type: ERROR_TYPE,
  errorCode,
});

export const setShowSuccess = (showSuccess) => ({
  type: SHOW_SUCCESS,
  showSuccess,
});

export const setIsLoggedIn = () => ({
  type: IS_LOGGED_IN,
});

export const setLoyaltyAvailableToCustomer = (loyaltyAvailableToCustomer) => ({
  type: SET_LOYALTY_AVAILABLE,
  loyaltyAvailableToCustomer,
});

export const setLoyaltyData = (loyaltyData) => ({
  type: SET_LOYALTY_DATA,
  loyaltyData,
});

export const setCurrentTierId = (currentTierId) => ({
  type: SET_CURRENT_TIER_ID,
  currentTierId,
});

// eslint-disable-next-line complexity
export const joinLoyaltyReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case ERROR_TYPE:
      return {
        ...state,
        errorCode: action.errorCode,
      };
    case SHOW_SUCCESS:
      return {
        ...state,
        showSuccess: action.showSuccess,
      };
    case IS_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: true,
      };
    case SET_LOYALTY_AVAILABLE:
      return {
        ...state,
        loyaltyAvailableToCustomer: action.loyaltyAvailableToCustomer,
      };
    case SET_LOYALTY_DATA:
      return {
        ...state,
        loyaltyData: action.loyaltyData,
      };
    case SET_CURRENT_TIER_ID:
      return {
        ...state,
        currentTierId: action.currentTierId,
      };
    default:
      return state;
  }
};
